"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gen_broguesque = exports.gen_broguesque_container = void 0;
var diveObjects_sidecar_1 = require("@dive/entities/diveObjects-sidecar");
var diveTileData_1 = require("@dive/tilemap/diveTileData");
var diveTileData_sidecar_1 = require("@dive/tilemap/diveTileData-sidecar");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var diveTilemapPart_sidecar_1 = require("@dive/tilemap/diveTilemapPart-sidecar");
var randoInstanced_sidecar_1 = require("@dive/to-engine/randoInstanced-sidecar");
var genUtils_sidecar_1 = require("../common/genUtils-sidecar");
var gen_clear_sidecar_1 = require("../common/gen_clear-sidecar");
var gen_outsideWalls_sidecar_1 = require("../diabloesque/gen_outsideWalls-sidecar");
var gen_removeBorderWalls_sidecar_1 = require("../diabloesque/gen_removeBorderWalls-sidecar");
var gen_shadows_sidecar_1 = require("../diabloesque/gen_shadows-sidecar");
var gen_stairs_sidecar_1 = require("../diabloesque/gen_stairs-sidecar");
var gen_addObjects_sidecar_1 = require("./gen_addObjects-sidecar");
var gen_monsters_sidecar_1 = require("./gen_monsters-sidecar");
var gen_roomGeneration_sidecar_1 = require("./gen_roomGeneration-sidecar");
var gen_addObjects_1 = require("./gen_addObjects");
var _debug_slowmo = false;
function gen_broguesque_container(options) {
    var iAttempt, seed, subgen, isDone, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                iAttempt = 0;
                _a.label = 1;
            case 1:
                if (!(iAttempt < 100)) return [3 /*break*/, 6];
                seed = Date.now();
                seed += iAttempt;
                seed %= 99999999;
                console.log('gen_broguesque_container attempt', iAttempt + 1);
                subgen = gen_broguesque(seed, options);
                isDone = false;
                _a.label = 2;
            case 2:
                if (!true) return [3 /*break*/, 4];
                result = subgen.next();
                if (result.done) {
                    isDone = true;
                    return [3 /*break*/, 4];
                }
                if (result.value.command === 'reset') {
                    console.log('gen_cathedral_container', 'resetting', result.value.reason || 'unknown reason');
                    return [3 /*break*/, 4];
                }
                return [4 /*yield*/, result.value];
            case 3:
                _a.sent();
                return [3 /*break*/, 2];
            case 4:
                if (isDone) {
                    return [3 /*break*/, 6];
                }
                _a.label = 5;
            case 5:
                iAttempt++;
                return [3 /*break*/, 1];
            case 6: 
            // Done generating cathedral!
            // on_levelGenerated()
            return [2 /*return*/, undefined];
        }
    });
}
exports.gen_broguesque_container = gen_broguesque_container;
function gen_broguesque(seed, options) {
    var rnd, delay, isSafeRoom, axis, _a, sizeX, sizeY, info, i, i, minFloors, minStairDistance, itemsMultiplier, hole, j, i, gs;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                // Clear entities
                diveObjects_sidecar_1.diveObjects.killAll();
                gen_clear_sidecar_1.gen_clear.clearTilemap();
                rnd = randoInstanced_sidecar_1.randoInstanced.createRando(seed);
                console.log('seed is', seed, rnd.getCurrentSeed());
                delay = 0.0001;
                if (_debug_slowmo) {
                    delay = 0.01;
                }
                isSafeRoom = options.isSafeRoom;
                axis = 'x';
                _a = __read(diveTilemap_sidecar_1.diveTilemap.getSize(), 2), sizeX = _a[0], sizeY = _a[1];
                info = {
                    openFloors: [],
                    rooms: [],
                    startingRooms: [],
                    sizeX: sizeX,
                    sizeY: sizeY,
                    rnd: rnd,
                    delay: delay,
                    options: options,
                };
                // Init hyperspace
                gen_roomGeneration_sidecar_1.gen_roomGeneration.initHyperspace();
                for (i = 0; i < 1; i++) {
                    // Create first room
                    gen_roomGeneration_sidecar_1.gen_roomGeneration.createHyperspaceRoom(info, { minSize: 11, maxSize: 11 });
                    // Place first room
                    gen_roomGeneration_sidecar_1.gen_roomGeneration.placeHyperspaceRoom_inCenter(info);
                }
                // Place more rooms
                if (!isSafeRoom) {
                    for (i = 0; i < 3; i++) {
                        gen_roomGeneration_sidecar_1.gen_roomGeneration.createHyperspaceRoom(info, { minSize: 4, maxSize: 16 });
                        gen_roomGeneration_sidecar_1.gen_roomGeneration.tryAccreteRoom(info);
                    }
                }
                // if (axis === 'x') {
                //   gen_centralHallway.addCentralHallway(info)
                //   yield { delay }
                //   yield* gen_startingRooms.addStartingRooms(info)
                // }
                // // Bud off of starting rooms
                // axis = flipAxis(axis)
                // for (let sr of info.startingRooms) {
                //   console.log('processsing starting room', axis)
                //   yield { delay }
                //   yield* gen_L5roomGen.L5roomGen(info, sr, axis, false)
                // }
                // yield* gen_divideRooms.divideRooms(info)
                return [5 /*yield**/, __values(gen_outsideWalls_sidecar_1.gen_outsideWalls.addOutsideWalls(info))
                    // gen_startingRooms.addColumns(info)
                    // gen_centralHallway.addCentralArch(info)
                    // TODO: theme room insertion
                    // TODO: misc cleanup matching, and variants
                    // TODO: add treasure
                    // TODO: add enemies
                    // TODO: add heroes
                    // Count walkable tiles and restart if below threshold
                ];
            case 1:
                // if (axis === 'x') {
                //   gen_centralHallway.addCentralHallway(info)
                //   yield { delay }
                //   yield* gen_startingRooms.addStartingRooms(info)
                // }
                // // Bud off of starting rooms
                // axis = flipAxis(axis)
                // for (let sr of info.startingRooms) {
                //   console.log('processsing starting room', axis)
                //   yield { delay }
                //   yield* gen_L5roomGen.L5roomGen(info, sr, axis, false)
                // }
                // yield* gen_divideRooms.divideRooms(info)
                _b.sent();
                // gen_startingRooms.addColumns(info)
                // gen_centralHallway.addCentralArch(info)
                // TODO: theme room insertion
                // TODO: misc cleanup matching, and variants
                // TODO: add treasure
                // TODO: add enemies
                // TODO: add heroes
                // Count walkable tiles and restart if below threshold
                genUtils_sidecar_1.genUtils.collectFreeSpots(info);
                minFloors = 10 // sizeX * sizeY * 0.4
                ;
                if (!(info.openFloors.length < minFloors)) return [3 /*break*/, 3];
                // restart!
                return [4 /*yield*/, { command: 'reset', reason: 'not enough floor' }];
            case 2:
                // restart!
                _b.sent();
                _b.label = 3;
            case 3:
                minStairDistance = 10 + info.options.levelNum * 5;
                if (info.options.isSafeRoom) {
                    minStairDistance = 3;
                }
                return [5 /*yield**/, __values(gen_stairs_sidecar_1.gen_stairs.placeStairs(info, {
                        minStairDistance: minStairDistance,
                    }))];
            case 4:
                _b.sent();
                if (!isSafeRoom) return [3 /*break*/, 8];
                return [5 /*yield**/, __values(gen_addObjects_sidecar_1.gen_addObjects.addLamps(info, 1, 3))
                    // TODO: add food? scatter and convert loot?
                ];
            case 5:
                _b.sent();
                if (!info.options.isStartingLevel) return [3 /*break*/, 8];
                return [5 /*yield**/, __values(gen_addObjects_sidecar_1.gen_addObjects.addInitialWeapons(info))];
            case 6:
                _b.sent();
                return [5 /*yield**/, __values(gen_addObjects_sidecar_1.gen_addObjects.addInitialPotions(info))];
            case 7:
                _b.sent();
                _b.label = 8;
            case 8:
                if (!!isSafeRoom) return [3 /*break*/, 13];
                itemsMultiplier = 1 + info.options.levelNum * 0.33;
                return [5 /*yield**/, __values(gen_addObjects_sidecar_1.gen_addObjects.addLamps(info, 5, 10))];
            case 9:
                _b.sent();
                return [5 /*yield**/, __values(gen_addObjects_sidecar_1.gen_addObjects.addTreasure(info, 1 * itemsMultiplier, 3 * itemsMultiplier))
                    // yield* gen_addObjects.addTestItems(info)
                ];
            case 10:
                _b.sent();
                // yield* gen_addObjects.addTestItems(info)
                return [5 /*yield**/, __values(gen_addObjects_sidecar_1.gen_addObjects.addBarrels(info, 3 * itemsMultiplier, 6 * itemsMultiplier))];
            case 11:
                // yield* gen_addObjects.addTestItems(info)
                _b.sent();
                if (!(info.options.levelNum > 5)) return [3 /*break*/, 13];
                return [5 /*yield**/, __values(gen_addObjects_1.addSpiderStuff(info, 5, 10))];
            case 12:
                _b.sent();
                _b.label = 13;
            case 13: return [5 /*yield**/, __values(gen_addObjects_sidecar_1.gen_addObjects.replaceDoorTilesWithDoorObjects(info))
                // Add gravel-fill
            ];
            case 14:
                _b.sent();
                hole = diveTileData_sidecar_1.diveTileData.get(diveTileData_1.EDiveTile.Hole);
                for (j = 0; j < sizeY; j++) {
                    for (i = 0; i < sizeX; i++) {
                        gs = diveTilemap_sidecar_1.diveTilemap.getUnsafe(i, j);
                        if (gs.tile1.type === diveTileData_1.EDiveTile.Acid) {
                            diveTilemapPart_sidecar_1.diveTilemapPart.setTile(gs, hole);
                        }
                    }
                }
                return [5 /*yield**/, __values(gen_removeBorderWalls_sidecar_1.gen_removeBorderWalls.removeBorderWalls())];
            case 15:
                _b.sent();
                return [5 /*yield**/, __values(gen_shadows_sidecar_1.gen_shadows.addShadows())];
            case 16:
                _b.sent();
                return [5 /*yield**/, __values(gen_monsters_sidecar_1.gen_monsters.gen_add_monsters(info))];
            case 17:
                _b.sent();
                return [2 /*return*/, undefined];
        }
    });
}
exports.gen_broguesque = gen_broguesque;
